import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpRightFromSquare, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

import "./styles/project.css";

const Project = (props) => {
	const { title, linkText, projectCover, gallery = [] } = props;
	const [isOpen, setIsOpen] = useState(false);
	const [currentIndex, setCurrentIndex] = useState(0);

	const handlePrev = () => {
		setCurrentIndex((prevIndex) => (prevIndex - 1 + gallery.length) % gallery.length);
	};

	const handleNext = () => {
		setCurrentIndex((prevIndex) => (prevIndex + 1) % gallery.length);
	};

	return (
		<>
			<div
				className="project"
				style={{ backgroundImage: `url(${projectCover})` }}
			>
				<div className="project-click-area" onClick={() => setIsOpen(true)}>
					<div className="project-container">
						<div className="project-title">{title}</div>
						<div className="project-link">
							<div className="project-link-icon">
								<FontAwesomeIcon icon={faUpRightFromSquare} />
							</div>
							<div className="project-link-text">{linkText}</div>
						</div>
					</div>
				</div>
			</div>

			{isOpen && (
				<div className="project-modal-overlay">
					<div className="project-modal">
						<div className="project-modal-header">
							<button className="project-close-btn" onClick={() => setIsOpen(false)}>Close</button>
						</div>
						{gallery.length > 0 && (
							<div className="project-gallery-single">
								{gallery[currentIndex].type === "video" ? (
									<video
										key={currentIndex}
										controls
										className="project-gallery-item"
									>
										<source src={gallery[currentIndex].src} type="video/mp4" />
										Your browser does not support the video tag.
									</video>
								) : gallery[currentIndex].type === "youtube" ? (
									<iframe
										key={currentIndex}
										src={`https://www.youtube.com/embed/${gallery[currentIndex].src}`}
										title="YouTube video player"
										frameBorder="0"
										allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
										allowFullScreen
										className="project-gallery-item"
									></iframe>
								) : (
									<img
										key={currentIndex}
										src={gallery[currentIndex].src}
										alt=""
										className="project-gallery-item"
									/>
								)}

								{/* Arrows */}
								<button className="gallery-arrow left" onClick={handlePrev}>
									<FontAwesomeIcon icon={faChevronLeft} />
								</button>
								<button className="gallery-arrow right" onClick={handleNext}>
									<FontAwesomeIcon icon={faChevronRight} />
								</button>
							</div>
						)}
					</div>
				</div>
			)}
		</>
	);
};

export default Project;
